module.exports = __webpack_public_path__ + "img/address-book.2e8b8dfc.svg";